import React, { Component } from "react";
import Icon from "@alboompro/boom-components/general/icon";
import { I18n } from "react-redux-i18n";
import cx from "classnames";

import RangeInput from "../RangeInput";
import InputRefHandlerHeight from "./InputsRefHandler/InputRefHandlerHeight";
import InputRefHandlerWidth from "./InputsRefHandler/InputRefHandlerWidth";
import ColorPicker from "../ColorPickerComponent";
import {
  PopoverWrapper,
  PropItem,
  PropHeader,
  PropLabel,
} from "./styles";
import Switch from "../SwitchComponent/Switch";
import CarouselComponent from "../Carousel/CarouselComponent";
import CarouselSlides from "./CarouselSlides";

const defaultValue = { 
  "color": {
    "r": 225,
    "g": 225,
    "b": 225,
    "a": 1
  },
  "type": "wave",
  "width": 100,
  "height": 100,
  "activateEffect": false,
  "reverse": false
}

class BackgroundPopover extends Component {
  firstInteraction = (keyName, value) => {
    const { updaterFn, name } = this.props;
    if (!keyName || !value) {
      updaterFn({ prop: name, value: {...defaultValue, activateEffect: true} });
      return;
    }
    updaterFn({ prop: name, value: { ...defaultValue, activateEffect: true, [keyName]: value } });
  }

  changeColor = (e) => {
    const { currentValue, name, updaterFn } = this.props;
    if (!currentValue) {
      this.firstInteraction('color', e.rgb);
      return
    }
    updaterFn({ prop: name, value: { ...currentValue, color: e.rgb } });
  };

  changeWidth = (e) => {
    const { currentValue, name, updaterFn } = this.props;
    if (!currentValue) {
      this.firstInteraction('width', e.target.value);
      return
    }
    updaterFn({
      prop: name,
      value: { ...currentValue, width: e.target.value },
    });
  };

  changeHeight = (e) => {
    const { currentValue, name, updaterFn } = this.props;
    if (!currentValue) {
      this.firstInteraction('height', e.target.value);
      return
    }
    updaterFn({
      prop: name,
      value: { ...currentValue, height: e.target.value },
    });
  };

  activateClick = () => {
    const { updaterFn, currentValue, name } = this.props;
    if (!currentValue) {
      this.firstInteraction('activateEffect', true);
      return;
    }
    const { activateEffect } = currentValue;
    updaterFn({ prop: name, value: {...currentValue, activateEffect: !activateEffect} });
  };

  reverseClick = () => {
    const { updaterFn, currentValue, name } = this.props;
    if (!currentValue) {
      this.firstInteraction('reverse', true);
      return
    }
    const { reverse } = currentValue;
    updaterFn({ prop: name, value: {...currentValue, reverse: !reverse} });
  };

  updateCarousel = ({prop, value}) => {
    const {updaterFn, currentValue, name} = this.props;
    if (!currentValue) {
      this.firstInteraction('type', value);
      return
    }
    updaterFn({prop: name, value: {...currentValue, type: value}})
  }

  render() {
    const { currentValue, widthOptions, heightOptions, topSide } = this.props;
    const values = currentValue || defaultValue;
    const { width, color, height, type, activateEffect, reverse } = values;
    const {
      min: minWidth,
      max: maxWidth,
      step: stepWidth,
    } = widthOptions || {};
    const {
      min: minHeight,
      max: maxHeight,
      step: stepHeight,
    } = heightOptions || {};

    return (
      <PopoverWrapper style={{position: 'relative'}}>
        <PropItem>
          <PropLabel>{I18n.t("editPanel.backgroundEffect.activate")}</PropLabel>
          <Switch value={activateEffect} onClick={this.activateClick} />
        </PropItem>
        <PropItem column>
          <PropLabel>{I18n.t("editPanel.backgroundEffect.type")}</PropLabel>
          <CarouselComponent 
            {...this.props}
            slides={CarouselSlides({topSide}).map((slide) => ({...slide, name: I18n.t(slide.name)}))}
            currentValue={type}
            updateFunction={this.updateCarousel}
          />
        </PropItem>
        <PropItem>
          <PropLabel>{I18n.t("editPanel.backgroundEffect.color")}</PropLabel>
          <ColorPicker
            color={!color ? currentValue : color}
            onChange={this.changeColor}
          />
        </PropItem>
        <PropItem column>
          <PropHeader style={{ justifyContent: "space-between" }}>
            <PropLabel>{I18n.t("editPanel.backgroundEffect.height")}</PropLabel>
            <InputRefHandlerHeight {...this.props} currentValue={values} />
          </PropHeader>
          <RangeInput
            min={minHeight}
            max={maxHeight}
            step={stepHeight}
            value={height}
            onChange={this.changeHeight}
          />
        </PropItem>

        <PropItem column>
          <PropHeader style={{ justifyContent: "space-between" }}>
            <PropLabel>{I18n.t("editPanel.backgroundEffect.width")}</PropLabel>
            <InputRefHandlerWidth {...this.props} currentValue={values} />
          </PropHeader>
          <RangeInput
            min={minWidth}
            max={maxWidth}
            step={stepWidth}
            value={width}
            onChange={this.changeWidth}
          />
        </PropItem>
        <PropItem>
          <PropLabel>{I18n.t("editPanel.backgroundEffect.flip")}</PropLabel>
          <Switch value={reverse} onClick={this.reverseClick} />
        </PropItem>

      </PopoverWrapper>
    );
  }
}
export default BackgroundPopover;
